"use client";

import dynamic from "next/dynamic";

const NewsDetail = dynamic(() => import("@/app/Components/Pages/NewsDetail"), {
  ssr: false,
});

export default function NewsDetailWrapper({ documentId }) {
  return <NewsDetail documentId={documentId} />;
}
